/* locksmith-klaviyo.js
   Intercepts Locksmith email form submissions, subscribes the email to Klaviyo
   Full Audience list, then grants Locksmith access by posting the resource.
*/
(function() {
  // Klaviyo settings - update if needed
  const KLAVIYO_COMPANY_ID = 'XJG3dJ';
  const KLAVIYO_FULL_LIST_ID = 'XY3cBT';

  function debugLog(...args) {
    if (window.console && window.console.log) console.log('[locksmith-klaviyo]', ...args);
  }

  async function subscribeToKlaviyo(email) {
    const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_COMPANY_ID}`;
    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_FULL_LIST_ID } } }
      }
    };

    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'revision': '2024-02-15',
          'content-type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      debugLog('Klaviyo response status', res.status);

      if (res.status === 200 || res.status === 202) return { success: true };
      const errorData = await res.json().catch(() => null);
      return { success: false, error: errorData };
    } catch (err) {
      return { success: false, error: err };
    }
  }

  // Intercept Locksmith resource form submissions and subscribe to Klaviyo first.
  // Use capture phase to ensure this runs before Locksmith's delegated handlers.
  document.addEventListener('submit', async function(event) {
    const form = event.target.closest && event.target.closest('.locksmith-resource-form');
    if (!form) return;

    event.preventDefault();
    // Prevent other submit handlers (e.g. legacy Mailchimp ajax handlers) from running
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    if (form.dataset.klaviyoHandled === '1') return;
    form.dataset.klaviyoHandled = '1';

    const emailInput = form.querySelector("input[type='email'], input[name='email'], input[name='EMAIL']");
    const submitBtn = form.querySelector("button[type='submit'], input[type='submit']");
    const email = emailInput ? (emailInput.value || '').trim() : '';

    // Inline message helpers
    function getMessageEl(form) {
      let el = form.querySelector('.locksmith-klaviyo-message');
      if (!el) {
        el = document.createElement('div');
        el.className = 'locksmith-klaviyo-message';
        el.style.marginTop = '8px';
        el.style.fontSize = '14px';
        el.style.lineHeight = '1.2';
        el.style.display = 'none';
        el.setAttribute('aria-live', 'polite');
        // Insert after submit button if present, otherwise append to form
        const after = form.querySelector("button[type='submit'], input[type='submit']");
        if (after && after.parentNode) after.parentNode.insertBefore(el, after.nextSibling);
        else form.appendChild(el);
      }
      return el;
    }

    function showMessage(form, message, isError) {
      const el = getMessageEl(form);
      el.textContent = message;
      el.style.display = 'block';
      el.style.color = isError ? '#b00020' : '#0a7f3b';
      el.style.background = isError ? 'rgba(176,0,32,0.06)' : 'rgba(10,127,59,0.04)';
      el.style.border = isError ? '1px solid rgba(176,0,32,0.12)' : '1px solid rgba(10,127,59,0.08)';
      el.style.padding = '8px 10px';
      el.style.borderRadius = '4px';
    }

    function clearMessage(form) {
      const el = form.querySelector('.locksmith-klaviyo-message');
      if (el) el.style.display = 'none';
    }

    if (!email) {
      // No email field found; fall back to original Locksmith behaviour
      debugLog('No email found on locksmith form — falling back to postResource');
      const data = (window.Locksmith && Locksmith.util) ? Locksmith.util.serializeForm(form) : {};
      if (window.Locksmith && Locksmith.postResource) {
        Locksmith.postResource(data, { spinner: false, container: 'locksmith-content' });
      } else {
        form.submit();
      }
      form.dataset.klaviyoHandled = '';
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showMessage(form, 'Please enter a valid email address', true);
      form.dataset.klaviyoHandled = '';
      return;
    }

    if (submitBtn) submitBtn.disabled = true;

    debugLog('Subscribing email to Klaviyo:', email);
    const result = await subscribeToKlaviyo(email);
    if (result.success) {
      debugLog('Klaviyo subscribe success — granting Locksmith access');
      const data = (window.Locksmith && Locksmith.util) ? Locksmith.util.serializeForm(form) : {};
      if (window.Locksmith && Locksmith.postResource) {
        Locksmith.postResource(data, { spinner: false, container: 'locksmith-content' });
      } else {
        form.submit();
      }
    } else {
      console.error('[locksmith-klaviyo] Klaviyo subscription failed', result.error);
      showMessage(form, 'Unable to subscribe at this time. Please try again.', true);
      if (submitBtn) submitBtn.disabled = false;
      form.dataset.klaviyoHandled = '';
      return;
    }
  }, true);

})();
